import { ManageThreadsApi, ThreadsApi, useAPIAction } from "melco-shared-logic";

export const useUploadThreadAsset = (threadId: string) => {
  const [uploadThreadAsset] = useAPIAction(
    ManageThreadsApi,
    async (api, file: Blob) => {
      let response = await api.threadsUpload({
        id: threadId,
        file: file,
      });

      return {
        successMessages: [{ message: "default" }],
        data: response,
      };
    },
    {
      translationPrefix: "managethreads.actions.assetupload",
    }
  );
  return {
    uploadThreadAsset,
  } as const;
};
